import { ServiceDependencies } from 'lib/core/services/magento'
import { apolloClient } from 'lib/core/services/magento/client'
import { ApolloQueryResult } from '@apollo/client'
import gql from 'graphql-tag'
import { jsonToGraphQLQuery } from 'lib/core/resources/helpers/jsonToGraphql'

export interface CustomerValidationQuery {
  customer: {
    email: boolean
  }
}

export const customerValidationQueryObject: CustomerValidationQuery = {
  customer: {
    email: true
  }
}

export type GetCustomerValidationQuery = () => Promise<ApolloQueryResult<any>>

export const createCustomerValidationQuery = ({ getQueries }: ServiceDependencies): GetCustomerValidationQuery => async () => {
  const query = getQueries().customerValidationQuery

  return apolloClient.query({
    query: gql`{${jsonToGraphQLQuery(query)}}`,
    fetchPolicy: 'no-cache'
  })
}
